import { useEffect, useState } from "react";
import axios from "axios";
import { apiURI, authErrorRedirect, DataGridTable } from "../common";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

export function AllUsers() {
  const [errors, setErrors] = useState();
  const [data, setData] = useState([]);
  const history = useNavigate();

  const title = "All Users";
  const description = "Click on a row to manage the user's privileges";
  const addUserButton = (
    <Grid item>
      <Button
        variant="contained"
        sx={{ mr: "20px" }}
        onClick={() => history("/addUser")}
      >
        Add user
      </Button>
    </Grid>
  );

  useEffect(() => {
    axios
      .get(`${apiURI}/auth/users`)
      .then((response) => {
        setData(response.data);
      })

      .catch((response) => {
        console.log("error in axios form call react");
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });
    // eslint-disable-next-line no-console
  }, []);

  function handleRowClick(event) {
    history(`/userDetails/${event.row.email}`);
  }

  errors && console.log({ errors });

  return (
    <Grid
      justifyContent="center"
      alignItems="center"
      sx={{
        marginLeft: "auto",
        marginRight: "auto",
        padding: 3,
      }}
    >
      <DataGridTable
        data={data}
        handleRowClick={handleRowClick}
        title={title}
        description={description}
        button={addUserButton}
      />
    </Grid>
  );
}
